import styled from '@emotion/styled';
import { Link } from '@mui/material';
import mixpanel from 'mixpanel-browser';
import { useState } from 'react';

import { toast } from '@/components/toast';
import { useAuth } from '@/services/auth';
import { logger } from '@/services/logger';

import { RecaptchaWrapper } from '@/components/RecaptchaWrapper/';
import ActionDialog from '../AccountActions/ActionDialog';

const ActionButton = styled(Link)<{ hidden: boolean }>`
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.secondary.main};
    &:hover {
        cursor: pointer;
        text-decoration: underline;
    }
    visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;

const ActionButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 14px;
    justify-content: flex-end;
`;

const DeleteTitle = styled.span`
    font-size: 1.6rem;
    display: flex;
    flex-direction: row;
`;

export const ResetPassword = () => {
    const { user, resetPassword } = useAuth();
    const [isForgotPasswordDialogOpen, setIsForgotPasswordDialogOpen] = useState(false);
    const resetPasswordIsEnabled = user?.provider === 'auth0';

    const onClick = () => setIsForgotPasswordDialogOpen(true);

    const handleResetPassword = async () => {
        mixpanel?.track('reset_password', { event: 'click' });
        try {
            await resetPassword();
        } catch (error) {
            const title = 'Failed to send email';
            logger.error(title, { error });
            toast.error({ title, toastId: 'reset_password-error-toast' });
        }
    };

    return (
        <>
            <ActionButtonsContainer>
                <RecaptchaWrapper withDisclaimer source="reset-password">
                    <ActionButton hidden={!resetPasswordIsEnabled} onClick={onClick}>
                        Reset password
                    </ActionButton>
                </RecaptchaWrapper>
            </ActionButtonsContainer>
            <ActionDialog
                open={isForgotPasswordDialogOpen}
                onClose={() => setIsForgotPasswordDialogOpen(false)}
                onCancel={() => setIsForgotPasswordDialogOpen(false)}
                title="Reset your password?"
                subtitle="We’ll send you a message to help you reset you reset your password"
                onSubmit={handleResetPassword}
                submitTitle={<DeleteTitle>Reset</DeleteTitle>}
            />
        </>
    );
};
